module.exports = __webpack_public_path__ + "img/icon-xiangqu.749f660b.svg";